<template>
	<div class="variable-income my-3">
		<b-row>
			<div v-if="show_contribution">
				<b-col cols="8">
					<b-form-group label="EPF Amount">
						<b-form-input v-model="form.epf" type="text"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col cols="8">
					<b-form-group label="SOCSO Amount">
						<b-form-input v-model="form.socso" type="text"></b-form-input>
					</b-form-group>
				</b-col>
			</div>
			<b-col cols="12">
				<el-checkbox v-if="!isForeigIncome" v-model="form.epf_excluded" class="mb-3">Exclude EPF</el-checkbox>
			</b-col>

			<b-form @submit.prevent="update">
				<b-col cols="12">
					<b-form-group label="Total Non-Sales Related Variable Income - OT, Meal Allowances..etc">
						<b-row>
							<b-col md="auto" cols="12" class="d-flex align-items-center my-2" v-for="(variable, index) in variables"
								:key="index">
								<CurrencyInput v-model="variable.amount"
									:options="currencyOptions"
									:inputPlaceholder="`Month ${index + 1}`" />
							</b-col>
						</b-row>
					</b-form-group>
					<b-button-group class="w-100">
						<b-button @click="addMonths" :disabled="variables.length >= 12" variant="outline-primary" class="mt-3">+
							Add</b-button>
						<b-button @click="removeMonths" :disabled="variables.length <= 0" variant="outline-danger" class="mt-3">-
							Remove</b-button>
					</b-button-group>
				</b-col>
				<!-- <b-col cols="4" class="mt-3">
                    <b-button block variant="primary" type="submit">Save</b-button>
                </b-col> -->
			</b-form>
		</b-row>
	</div>
</template>
<script>
import { Button, Checkbox } from 'element-ui'
import {
	notifyFunctionMixin,
	helperFunctionMixin,
	axios,
	services,
	getHeader
} from '@/assets/js/httpImports.js'
import { mapActions } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'
import { EventBus } from '@/main'
import CurrencyInput from '@/components/CurrencyInput'
import _ from 'lodash'

export default {
	name: 'variable-income',
	props: ['show_contribution', 'customer', 'main_form', 'currencyOptions'],
	components: {
		CurrencyInput,
		[Button.name]: Button,
		[Checkbox.name]: Checkbox,
	},
	mixins: [
		helperFunctionMixin,
		notifyFunctionMixin
	],
	computed: {
		isForeigIncome() {
			// return false
			const wc = _gHlp.getValue(this.main_form, 'working_country');
			return !_gHlp.isEmpty(wc) && wc != 'Malaysia';
		},
		currencyRate() {
			return _gHlp.getValue(this.main_form, 'foreign_currency');
		},
	},
	data() {
		return {
			variables:[],
			form: {
				epf: '',
				socso: '',
				epf_excluded: this.customer.incomes.main.is_ex_epf_vi ?? false
			},
			isCurrencyConverted: false 
		}
	},
	created() {
		EventBus.$on('collect-income-data', this.sendIncomeData);
	},
	watch: {
		customer: {
			handler: function (newValue) {
				this.isCurrencyConverted = false;
				if(!_gHlp.isEmpty(newValue)){
					this.initData();
				}
			},
			immediate: true
		},
		main_form: {
			handler: function (newValue) {
				if(!_gHlp.isEmpty(newValue)){
					this.initData();
				}
			},
			immediate: true
		},
	},
	methods: {
		...mapActions(useCustomerStore, ['getCustomer']),
		initData(){
			this.variables = _gHlp.getValue(this.customer,'incomes.variable',[]);
			console.log(this.variables[0].amount)
			console.log(this.isForeigIncome)
			console.log(this.isCurrencyConverted)
			if (this.isForeigIncome && !this.isCurrencyConverted) {
				this.variables.forEach(el => {
					el.amount = _gHlp.currencyFromRM(el.amount, this.currencyRate);
				});
				this.isCurrencyConverted = true;
			}
		},
		setData() {
			this.isCurrencyConverted = false
			let variables = this.variables.map(obj => {
				return {
					...(obj.customer_variable_income_id && { customer_variable_income_id: obj.customer_variable_income_id }),
					// amount: obj.amount
					amount: (this.isForeigIncome) ? _gHlp.currencyToRM(obj.amount, this.currencyRate) : obj.amount
				}
			})
			let data = {
				variables: variables,
				is_ex_epf_vi: this.form.epf_excluded,
			}

			if (this.show_contribution) {
				data = { ...data, gov_epf: this.form.epf, gov_sosco: this.form.socso };
			}

			return data
		},
		update() {
			let data = this.setData()
			axios.post(services.customer + 'customer/' + this.$route.params.customer_id + '/income/variables', data, { headers: getHeader() })
				.then(res => {
					this.notifySuccess('<b>Variable Income: ' + this.customer.name + '</b> - Successfully Updated.')
					this.getCustomer(this.$route.params.customer_id)
				})
				.catch(e => {
					this.errorFunction(e)
				})
		},
		addMonths() {
			if (this.variables.length < 12) {
				this.variables.push({ amount: null });
			}
		},
		removeMonths() {
			if (this.variables.length > 0) {
				this.variables.pop();
			}
		},
		sendIncomeData() {
			this.$emit('income-data-collected', this.setData());
		}
	}
}
</script>